/* Dettaglio Cornice Selezionata — Fotorecord
   Ascolta 'caoa:cornice-selected' e popola il panel. */

(function () {
  'use strict';

  function set(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text || '';
  }

  function setRow(rowId, value) {
    var row = document.getElementById(rowId);
    if (!row) return;
    row.style.display = value ? '' : 'none';
  }

  /* Mostra/nasconde una figure foto insieme alla sua immagine.
     Si azzera il src quando non c'è URL: lasciando quello del profilo precedente,
     un profilo senza foto mostrerebbe la foto di quello scelto prima. */
  /* Le foto arrivano da un JSON (asset profili / metafield cfg_profilo / metaobject
     montature), quindi NON passano dal filtro Liquid `image_url: width:` e il browser
     scaricherebbe il master 2362x2362 (~290 KB) per un riquadro da 312 px. 640 = la
     larghezza CSS massima della figura, raddoppiata per il retina. */
  var FOTO_W = 640;

  function _thumb(url) {
    var core = window.FOTORECORD && window.FOTORECORD.core;
    return core && core.thumbUrl ? core.thumbUrl(url, FOTO_W) : url;
  }

  function setFoto(figId, imgId, url, alt) {
    var fig = document.getElementById(figId);
    var img = document.getElementById(imgId);
    if (!fig || !img) return;
    if (url) {
      img.src = _thumb(url);
      img.alt = alt || '';
      fig.style.display = '';
    } else {
      img.removeAttribute('src');
      img.alt = '';
      fig.style.display = 'none';
    }
  }

  /* Coda di figure supplementari, una per URL: le montature portano gli scatti
     `montatura{id_db}_5`, `_6`, … del prodotto-montatura (vademecum §6 — la
     numerazione parte da 5 perché le prime quattro posizioni hanno un nome parlante).
     Senza didascalia di proposito: di uno scatto generico non sappiamo cosa mostra.
     Si rigenerano a ogni cambio profilo — restando quelle di prima, un profilo senza
     coda erediterebbe le foto del precedente. Le due figure canoniche, che hanno un
     id e vivono nel markup della section, non si toccano.
     Ritorna quante ne ha disegnate: serve a decidere se il blocco si mostra. */
  function setFotoExtra(blk, urls, codice) {
    var grid = blk.querySelector('.ocds-foto-grid');
    if (!grid) return 0;
    var vecchie = grid.querySelectorAll('.ocds-foto-fig--extra');
    for (var v = 0; v < vecchie.length; v++) grid.removeChild(vecchie[v]);
    if (!urls || !urls.length) return 0;
    var n = 0;
    for (var k = 0; k < urls.length; k++) {
      if (!urls[k]) continue;
      var fig = document.createElement('figure');
      fig.className = 'ocds-foto-fig ocds-foto-fig--extra';
      var img = document.createElement('img');
      img.className = 'ocds-foto-img';
      /* width/height come nel markup statico: senza, la griglia salta al caricamento */
      img.width = 320;
      img.height = 240;
      img.loading = 'lazy';
      img.alt = 'Montatura ' + (codice || '');
      img.src = _thumb(urls[k]);
      fig.appendChild(img);
      grid.appendChild(fig);
      n++;
    }
    return n;
  }

  /* Capitalizza la prima lettera (es. "moderno" → "Moderno") */
  function _cap(s) {
    s = (s || '').trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }

  /* Disegna sezione trasversale del profilo come SVG inline (fallback quando
     l'immagine reale del profilo non è disponibile nel JS asset) */
  function buildCrossSection(larghezzaMm, altezzaSezione, battenteMm) {
    if (!larghezzaMm) return null;

    var vW = 240, vH = 160;
    var rx = 50, ry = 15;
    var rw = 90;

    /* Altezza visiva proporzionale al rapporto reale altezza/larghezza */
    var rh = 72;
    if (altezzaSezione && larghezzaMm) {
      rh = Math.round((altezzaSezione / larghezzaMm) * rw);
      rh = Math.max(30, Math.min(rh, 110));
    }

    /* Zona battente proporzionale sull'altezza totale */
    var batH = 0;
    if (battenteMm > 0 && altezzaSezione > 0) {
      batH = Math.round((battenteMm / altezzaSezione) * rh);
      batH = Math.max(8, Math.min(batH, rh - 12));
    }

    var stroke  = 'rgba(0,0,0,.45)';
    var fill    = 'rgba(0,0,0,.08)';
    var fillBat = 'rgba(0,0,0,.18)';
    var dimClr  = 'rgba(0,0,0,.5)';
    var txtClr  = 'rgba(0,0,0,.65)';
    var font    = 'font-family="system-ui,sans-serif" font-size="9"';

    var s = '<svg viewBox="0 0 ' + vW + ' ' + vH + '" xmlns="http://www.w3.org/2000/svg" aria-label="Sezione trasversale profilo">';

    /* Corpo profilo */
    s += '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + rh + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.5"/>';

    /* Zona battente */
    if (batH > 0) {
      s += '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + batH + '" fill="' + fillBat + '" stroke="' + stroke + '" stroke-width="1.5"/>';
    }

    /* Larghezza sezione (asse orizzontale sotto il profilo) */
    var dimY = ry + rh + 10;
    s += '<line x1="' + rx + '" y1="' + dimY + '" x2="' + (rx + rw) + '" y2="' + dimY + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<line x1="' + rx + '" y1="' + (dimY - 4) + '" x2="' + rx + '" y2="' + (dimY + 4) + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<line x1="' + (rx + rw) + '" y1="' + (dimY - 4) + '" x2="' + (rx + rw) + '" y2="' + (dimY + 4) + '" stroke="' + dimClr + '" stroke-width="1"/>';
    s += '<text x="' + (rx + rw / 2) + '" y="' + (dimY + 12) + '" text-anchor="middle" fill="' + txtClr + '" ' + font + '>' + larghezzaMm + ' mm</text>';

    /* Altezza sezione (asse verticale a sinistra) */
    if (altezzaSezione > 0) {
      var dLx = rx - 14;
      var midY = ry + rh / 2;
      s += '<line x1="' + dLx + '" y1="' + ry + '" x2="' + dLx + '" y2="' + (ry + rh) + '" stroke="' + dimClr + '" stroke-width="1"/>';
      s += '<line x1="' + (dLx - 4) + '" y1="' + ry + '" x2="' + (dLx + 4) + '" y2="' + ry + '" stroke="' + dimClr + '" stroke-width="1"/>';
      s += '<line x1="' + (dLx - 4) + '" y1="' + (ry + rh) + '" x2="' + (dLx + 4) + '" y2="' + (ry + rh) + '" stroke="' + dimClr + '" stroke-width="1"/>';
      s += '<text x="' + (dLx - 8) + '" y="' + midY + '" text-anchor="middle" fill="' + txtClr + '" transform="rotate(-90 ' + (dLx - 8) + ' ' + midY + ')" ' + font + '>' + altezzaSezione + ' mm</text>';
    }

    /* Altezza battente (asse verticale a destra) */
    if (batH > 0 && battenteMm > 0) {
      var dRx = rx + rw + 12;
      s += '<line x1="' + dRx + '" y1="' + ry + '" x2="' + dRx + '" y2="' + (ry + batH) + '" stroke="' + dimClr + '" stroke-width="1"/>';
      s += '<line x1="' + (dRx - 4) + '" y1="' + ry + '" x2="' + (dRx + 4) + '" y2="' + ry + '" stroke="' + dimClr + '" stroke-width="1"/>';
      s += '<line x1="' + (dRx - 4) + '" y1="' + (ry + batH) + '" x2="' + (dRx + 4) + '" y2="' + (ry + batH) + '" stroke="' + dimClr + '" stroke-width="1"/>';
      var lblX = dRx + 8;
      var lblY = ry + batH / 2 + 3;
      s += '<text x="' + lblX + '" y="' + lblY + '" fill="' + txtClr + '" ' + font + '>' + battenteMm + ' mm</text>';
      s += '<text x="' + lblX + '" y="' + (lblY + 11) + '" fill="' + dimClr + '" font-size="7" font-family="system-ui,sans-serif" opacity=".7">battente</text>';
    }

    s += '</svg>';
    return s;
  }

  function updatePanel(profilo) {
    var placeholder = document.getElementById('ocds-placeholder');
    var detail      = document.getElementById('ocds-detail');
    if (!placeholder || !detail) return;

    if (!profilo) {
      placeholder.style.display = '';
      detail.style.display = 'none';
      return;
    }

    placeholder.style.display = 'none';
    detail.style.display = '';

    /* Codice prodotto mostrato al cliente = id_db (CLAUDE.md § Identificatore unico), in
       vetrina MAIUSCOLO (docs/convenzioni.md § Superfici: FRAS0020, il dato resta fras0020).
       Nei dati profilo lo sku E' gia' l'id_db; toIdDb normalizza le sorgenti non ancora
       migrate. Il codice sta NEL nome: titolo leggibile (titolo prodotto prima del «|»)
       + codice pubblico, come in ogni scheda dal 15/09/2026 (codice_prodotto.nome_cliente).

       Il codice SEZIONE si ricava dal nome file di sezioneUrl (.../151510.webp), che e' la
       sezione stessa: non si puo' piu' derivare spezzando il codice sui trattini, perche'
       l'id_db non ne ha. Quello split era comunque gia' impreciso sulle sezioni con suffisso
       ('132310-2-ss-blu' dava '132310' invece di '132310-2'). Fallback: prefisso numerico. */
    var core      = window.FOTORECORD && window.FOTORECORD.core;
    var codiceDb  = profilo.sku ? (core && core.toIdDb ? core.toIdDb(profilo.sku) : profilo.sku) : '';
    var codice    = (core && core.pubblico) ? core.pubblico(codiceDb) : codiceDb.toUpperCase();
    var nomeProf  = (core && core.nomeCliente)
      ? core.nomeCliente(profilo.nome_breve || profilo.nomeBreve || String(profilo.nome || '').split('|')[0].trim(), codiceDb)
      : (String(profilo.nome || '').split('|')[0].trim() + ' ' + codice).trim();
    var stemSez   = (profilo.sezioneUrl || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
    var codiceSez = stemSez || (codiceDb.match(/^\d+/) || [codice])[0];

    set('ocds-nome',            nomeProf);
    set('ocds-sezione-codice',  codiceSez);
    set('ocds-stile',           _cap(profilo.stile));
    set('ocds-colore',          profilo.colore);
    set('ocds-finitura',        profilo.finitura);
    set('ocds-larghezza',       profilo.larghezzaMm    ? profilo.larghezzaMm    + ' mm' : '');
    set('ocds-altezza-sezione', profilo.altezzaSezione ? profilo.altezzaSezione + ' mm' : '');
    set('ocds-battente',        profilo.battenteMm     ? profilo.battenteMm     + ' mm' : '');

    setRow('ocds-row-stile',           profilo.stile);
    setRow('ocds-row-colore',          profilo.colore);
    setRow('ocds-row-finitura',        profilo.finitura);
    setRow('ocds-row-larghezza',       profilo.larghezzaMm);
    setRow('ocds-row-altezza-sezione', profilo.altezzaSezione);
    setRow('ocds-row-battente',        profilo.battenteMm);

    /* Nasconde l'intero blocco "Sezione del profilo" quando non ci sono dati di
       sezione (es. montature a giorno, che condividono questo pannello). */
    var hasSezione = profilo.larghezzaMm || profilo.altezzaSezione || profilo.battenteMm || profilo.sezioneUrl;
    var blkSezione = document.getElementById('ocds-block-sezione');
    if (blkSezione) blkSezione.style.display = hasSezione ? '' : 'none';

    /* Immagine swatch prodotto.
       `imgFilo` dice che il master NON e' un render di cornice ma il solo filo
       perimetrale da 4 mm su centro trasparente (montature a giorno): il taglio a
       quadrante mostrerebbe una L sottile in un quadrato vuoto, quindi si adotta lo
       stesso taglio della cella di galleria — vedi .ocds-img--filo in
       opera-cornice-detail.liquid, che ne porta la geometria.
       Chiave dedicata e non l'assenza di `larghezzaMm`: dedurre il tipo di master da un
       campo che parla d'altro e' esattamente l'errore del 20/08 sulla live view. */
    var img      = document.getElementById('ocds-img');
    var fallback = document.getElementById('ocds-img-fallback');
    var imgWrap  = document.getElementById('ocds-img-wrap');
    if (img && fallback) {
      /* Senza master non si passa alla striscia: il riquadro deve restare quadrato per
         contenere il segnaposto grigio da 48 px (`.ocds-img-fallback`). */
      var filo = profilo.imgFilo === true && !!profilo.imgUrl;
      img.classList.toggle('ocds-img--filo', filo);
      if (imgWrap) imgWrap.classList.toggle('mdet-media__wrap--filo', filo);
      if (profilo.imgUrl) {
        img.src            = profilo.imgUrl;
        img.alt            = profilo.nome || '';
        img.style.display  = '';
        fallback.style.display = 'none';
      } else {
        img.style.display      = 'none';
        fallback.style.display = '';
      }
    }

    /* Foto reali del profilo (barra + campione d'angolo).
       Sono opzionali: ~200 profili su 489 non sono ancora fotografati, e i profili
       montatura arrivano da un metaobject che questi campi non li porta affatto. In
       entrambi i casi il blocco non si disegna — mai un riquadro vuoto o un'immagine
       rotta. Le singole foto sono indipendenti: alcune aste hanno il campione ma non
       l'angolo. */
    var fotoCampione = profilo.fotoCampioneUrl || '';
    var fotoAngolo   = profilo.fotoAngoloUrl   || '';
    /* Ripiego: quando barra e angolo non ci sono, valgono le altre immagini del
       prodotto — ma NON sono la barra e l'angolo, quindi le didascalie si tacciono
       invece di mentire su cosa sta guardando il cliente. */
    var generiche    = profilo.fotoFallback === true;
    var blkFoto      = document.getElementById('ocds-block-foto');
    if (blkFoto) {
      setFoto('ocds-foto-fig-campione', 'ocds-foto-campione', fotoCampione,
              generiche ? 'Profilo ' + (codice || '')
                        : 'Asta ' + (codice || '') + ' — foto del profilo');
      setFoto('ocds-foto-fig-angolo', 'ocds-foto-angolo', fotoAngolo,
              generiche ? 'Profilo ' + (codice || '')
                        : 'Asta ' + (codice || '') + ' — campione d’angolo');
      var caps = blkFoto.querySelectorAll('.ocds-foto-cap');
      for (var i = 0; i < caps.length; i++) caps[i].style.display = generiche ? 'none' : '';
      var nExtra = setFotoExtra(blkFoto, profilo.fotoExtraUrl, codice);
      blkFoto.style.display = (fotoCampione || fotoAngolo || nExtra) ? '' : 'none';
    }

    /* Immagine sezione profilo (reale) o diagramma SVG generato come fallback */
    var sezioneImg = document.getElementById('ocds-sezione-img');
    var diag       = document.getElementById('ocds-section-diagram');
    if (sezioneImg && diag) {
      if (profilo.sezioneUrl) {
        sezioneImg.src         = profilo.sezioneUrl;
        sezioneImg.alt         = 'Sezione profilo ' + (profilo.nome || '');
        sezioneImg.style.display = '';
        diag.style.display       = 'none';
      } else {
        sezioneImg.style.display = 'none';
        var svgMarkup = buildCrossSection(profilo.larghezzaMm, profilo.altezzaSezione, profilo.battenteMm);
        if (svgMarkup) {
          diag.innerHTML     = svgMarkup;
          diag.style.display = '';
        } else {
          diag.style.display = 'none';
        }
      }
    }
  }

  document.addEventListener('caoa:cornice-selected', function (e) {
    updatePanel(e.detail);
  });

  /* Mostra il profilo già selezionato al caricamento (per aste/montature che
     dispatchano durante il loro init, prima che questo listener fosse pronto) */
  setTimeout(function () {
    if (window._CAOA_PROFILO) updatePanel(window._CAOA_PROFILO);
  }, 0);
})();
